.text {
    display: flex;
    flex-direction: column;
    min-width: 0;
    padding-left: 16px;
    padding-right: 16px;
    padding-top: 8px;
    text-decoration: none;
    cursor: pointer;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

.text:hover {
    background-color: var(--hps-light-gray);
}

/* Ensures that text is correctly ellipsized. */
.text > p {
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.selected {
    background-color: #8fa4afaf;
    z-index: 1;
}

.selected:hover {
    background-color: #8fa4af80;
    z-index: 1;
}
